import React from 'react';
import '../bootstrap.min.css';

function AboutUs() {
    return (
        <div className="container py-5">
            <div className="row mb-4 mb-lg-5">
                <div className="col-md-8 col-xl-6 text-center mx-auto">
                    <h2 className="fw-bold">About Us</h2>
                </div>
            </div>
            <div className="mx-auto">
                <br />
                <h2>What's All This About?</h2>
                <p>
                    <span className="fw-bold text-success mb-2">
                        “Musical innovation is full of danger to the State, for when modes of music change, the fundamental laws of the State always change with them.”
                    </span> – Plato
                </p>
                <br />
                <h2>What Are We Doing?</h2>
                <p className="fw-bold text-success mb-2">We're building a self-sustaining creative community.</p>
                <p>– Producing, sharing, and supporting <strong>independent art and media</strong>.</p>
                <p>– Using alternative <strong>mediums of exchange</strong> (time, skills, food, coffee, crypto—not centralised fiat).</p>
                <p>– Building on <strong>decentralised, resilient infrastructure</strong> to ensure creative freedom.</p>
                <p>– Supporting <strong>local makers and independent businesses</strong> instead of global corporations aligned with elite interests.</p>
                <br />
                <p>
                    <span className="fw-bold text-success mb-2">
                        “The secret of change is to focus all of your energy, not on fighting the old, but on building the new.”
                    </span> – Socrates
                </p>
                <br />
                <h2>Why Music?</h2>
                <p>
                    Gigs are modern rituals. Music creates belonging, and stories carry culture. We're using events, food, song, and solar-powered production to help meet real human needs—from nourishment to self-actualisation.
                </p>
                <br />
                <h2>How to Get Involved</h2>
                <br />
                <p className="fw-bold text-success mb-2">Artists</p>
                <p>
                    We're selective right now—resources are limited. But we love hearing demos. They don’t need to be polished. Just send a link (SoundCloud, Google Drive, etc.) to
                    <span className="fw-bold text-success"> info@blindnightrecords.com</span> with the subject line "<strong>Submission</strong>".
                </p>
                <br />
                <p className="fw-bold text-success mb-2">Freelancers</p>
                <p>
                    We don’t price people’s time—we value contribution. We collaborate on a project-by-project basis, agreeing fair terms based on mutual need and respect.
                </p>
                <br />
                <p className="fw-bold text-success mb-2">Companies</p>
                <p>
                    We do not work with organisations that compromise artist integrity. We oppose deadnaming under the guise of ‘historical accuracy’. We're not affiliated with MusicBrainz, and they do not have our permission to publish or alter data on our catalogue.
                </p>
                <br />
                <p>
                    If you believe in storytelling, mutual aid, and building something worth passing down—then come join us.
                </p>
            </div>
        </div>
    );
}

export default AboutUs;